import {Component, OnInit, Input} from '@angular/core';
import {Router} from '@angular/router';

import {IMyDateModel} from 'mydatepicker';

import {AppComponent} from './app.component';

import {PlacementService} from './placement.service';

@Component({
    selector: 'locations',
    templateUrl: './templates/locations.component.html',
    styleUrls: ['./styles/products-list.component.css', './styles/locations.component.css'],
    providers: [PlacementService]
})
export class LocationsComponent implements OnInit {
    //    list
    docket_name: string = "";
    docket_date: string = "";

    docket_list: Array<any> = [];

    operation_bt: string = "Placer";

    //    placer
    place: boolean = false;
    docket_to_place: Array<any> = [];
    docket_infos: string = '';

    constructor(
        private app_component: AppComponent,
        private router: Router,
        private placement_service: PlacementService,
    ) {
        this.app_component.valTest = '/locations';
        this.app_component.GetParent();
    }

    ngOnInit() {
    }

    Place(docket: any) {
        this.GetDocketDetails(docket);
        this.place = true;
    }

    GetDocketDetails(docket: any) {
        this.docket_infos = '(' + docket.reference_code + ' - ' + docket.docket_name + ' / ' + docket.timestamp + ')';
        this.placement_service.DetailsDocket(docket.id_docket)
            .then(response => {
                this.docket_to_place = response['list'];
                //                this.docket_to_place[0]['default_emplacement'] = this.docket_to_place[0]['location'][0]['id_location'];
            });
    }

    EditLinePlacement(docket: any) {
        this.placement_service.EditLinePlacement(docket.id_movement)
            .then(response => {
                this.docket_to_place = response['list'];
                //                this.docket_to_place[0]['default_emplacement'] = this.docket_to_place[0]['location'][0]['id_location'];
            });
    }

    operationBt() {

    }

    ChangeStatePlacer(place: any) {
        console.log(place);
        this.place = false;
    }

    FormatPrice(price: any): string {
        return Math.round(price).toLocaleString() + ' Ar';
    }

    article_to_place: any;
    add_location: boolean = false;
    name_article_to_place: string = '';
    article_locations_list: Array<any> = [];

    nbr_to_place: any = 0;
    id_article: any = 0;

    movement_tempo: any;

    ShowLocationsForThisDocket(article: any) {
        this.movement_tempo = article;
        this.name_article_to_place = article.name + ' - ' + 'Quantité : ' + article.quantity_to_place;
        this.add_location = true;
        this.app_component.hide_wrapper(this.add_location);
        this.GetLocationsForThisArticle(article.id_article, article.quantity_to_place);
    }

    SetLocation(event: any) {
        if (event.action == 'RECEPTION') {
            this.EditLinePlacement(event);
        } else if (event.action == 'EDITION') {
            this.placement_service.SetLocationForThisLine(event.id_movement, event.default_emplacement)
                .then(response => {
                    if (Number(response['result']) == 0) {
                        this.docket_to_place = response['list_right'];
                        this.docket_list = response['list_left'];
                    } else {
                        this.ShowLocationsForThisDocket(event);
                        this.id_article = event.id_article;
                    }
                });
        }
    }

    SetLocationsForThisLine() {
        var emplacements = '';
        for (var i = 0; i < this.article_locations_list.length; i++) {
            if (Number(this.article_locations_list[i]['to_place']) != 0) {
                emplacements = emplacements + '' + this.article_locations_list[i]['id_location'] + ':' + this.article_locations_list[i]['to_place'] + '_';
            }
        }
        this.placement_service.SetLocationsForThisLine(this.movement_tempo.id_movement, emplacements)
            .then(response => {
                this.docket_to_place = [];
                this.docket_list = response['list_left'];
                this.Cancel();
            });
    }

    infos_article: any = {
        id_article: '',
        quantity: ''
    }

    GetLocationsForThisArticle(id_article: any, quantity: any) {
        this.nbr_to_place = 0;
        this.infos_article.id_article = id_article;
        this.infos_article.quantity = quantity;
        this.placement_service.GetLocationsForThisArticle(id_article, quantity)
            .then(response => {
                this.article_locations_list = response['list'];
                this.GetNbrResteToPlace();
            });
    }

    GetNbrResteToPlace() {
        var tmp = 0;
        for (var i = 0; i < this.article_locations_list.length; i++) {
            tmp = tmp + Number(this.article_locations_list[i].to_place);
        }
        this.nbr_to_place = Number(this.infos_article.quantity) - tmp;
        tmp = 77;
    }

    LimitResteToPlace(docket: any, saisi: any) {
        saisi = Number(saisi);

        var total_placed = 0;
        var tmp_saisi = 0;

        for (var i = 0; i < this.article_locations_list.length; i++) {
            if (this.article_locations_list[i].id_location != docket.id_location) {
                total_placed = total_placed + Number(this.article_locations_list[i].to_place);
            }
        }
        var nbr_to_place_without = Number(this.infos_article.quantity) - total_placed;

        for (var i = 0; i < saisi && i < (docket.maximum_capacity - docket.current_quantity) && i < nbr_to_place_without; i++) {
            tmp_saisi++;
        }
        saisi = tmp_saisi;
        docket.to_place = saisi;
        this.GetNbrResteToPlace();
    }

    Cancel(): void {
        this.add_emplacement = false;
        this.add_location = false;
        this.app_component.hide_wrapper(this.add_location);
    }

    CancelView(): void {
        this.add_emplacement = false;
        this.view_locations = false;
        this.app_component.hide_wrapper(this.view_locations);
    }

    view_locations: boolean = false;
    view_article_locations_list: Array<any> = [];

    ViewLocation(event: any) {
        this.name_article_to_place = event.name + ' - ' + 'Quantité : ' + event.quantity;
        this.view_locations = true;
        this.app_component.hide_wrapper(this.view_locations);
        this.placement_service.GetLocationsForThisLine_ForView(event.id_movement)
            .then(response => {
                this.view_article_locations_list = response['list'];
            });
    }

    add_emplacement: boolean = false;
    AddEmplacement() {
        this.add_emplacement = true;
    }

    CloseEmplacement(event: any) {
        this.add_emplacement = false;
        this.article_locations_list = event;
        this.GetNbrResteToPlace();
    }
}



// WEBPACK FOOTER //
// ./src/app/locations.component.ts